<div class="profile person-content" *ngIf="person">
  <div class="header">
    <div class="image" [ngStyle]="{'background-image': 'url('+person.picture+')'}"></div>
    <div class="info">
      <h2>{{ person.name }}</h2>
      <div class="divider"></div>
      <p class="flex items-center"><img src="assets/icons/doctor.png" width="20" alt="doctor"/>{{ person.job }}</p>
      <p><a [href]="'tel:' + person.mobileHref"><img src="assets/icons/phone.png" alt="phone" width="20"/> {{ person.mobile }}</a>
      </p>
    </div>
  </div>
  <div class="text-content" [innerHTML]="person.intro">
  </div>
</div>
